<script>
    import { initSliderFilter } from '../../libs/range-slide';
    import { SEARCH_TYPES } from '../../libs/typefactories';
    import { query } from "../../libs/stores";

    export let min;
    export let max;

    $: start = ($query.search_terms.find(it => it.type === SEARCH_TYPES.RANGE_YEAR_FILTER) || { value: [min, max] }).value;
</script>
<div class="c-years-filter">
    <div class="c-years-filter__label">Filtra per periodo:</div>
    <div id="years-filter" class="c-years-filter__container" on:change use:initSliderFilter={{min, max, start}}></div>
</div>
